up.compiler('[update-new-messages-count]', { batch: true }, (element) => {
  up.emit('app:update-new-messages-count')
})
